/**
 * WordPress dependencies
 */
export * from '@wordpress/edit-post';
